import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) { nav("/login", { replace: true }); return; }
      const session_id = decodeURIComponent(match[1]);
      try {
        const { data } = await api.post("/auth/google-session", { session_id });
        setUser(data);
        // Strip the fragment from URL
        window.history.replaceState(null, "", window.location.pathname);
        const dest = data.role === "admin" ? "/admin"
          : data.role === "vendor" ? "/vendor"
          : "/account";
        nav(dest, { replace: true });
      } catch (e) {
        console.error("Google sign-in failed:", e);
        toast.error("Google sign-in failed. Please try again.");
        window.history.replaceState(null, "", window.location.pathname);
        nav("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Certif. № TS-2026 · Signing you in</p>
        <p className="font-serif text-4xl mt-4 tracking-tighter">One moment…</p>
      </div>
    </div>
  );
}
